<template>
    <Line :data="chartData" :options="chartOptions" />
  </template>
  
  <script>
  import { Line } from 'vue-chartjs';
  import { Chart, registerables } from 'chart.js';
  import zoomPlugin from 'chartjs-plugin-zoom';
  import 'chartjs-adapter-date-fns';
  
  Chart.register(...registerables, zoomPlugin);
  
  export default {
    name: 'CycleLengthChart',
    components: { Line },
    props: {
      labels: Array,
      cycleLengthData: Array,
    },
    computed: {
      chartData() {
        return {
          labels: this.labels,
          datasets: [
            {
              label: 'Cycle Length',
              data: this.cycleLengthData,
              borderColor: '#FF6384', // Customize the color
              fill: false,
            },
          ],
        };
      },
      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          layout: { padding: 10 },
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'hour',
                tooltipFormat: 'yyyy-MM-dd HH:mm:ss',
              },
              ticks: {
                maxTicksLimit: 10,
                autoSkip: true,
              },
            },
            y: {
              beginAtZero: true,
              min: 10, // Add buffer
              max: 90,
              ticks: {
                stepSize: 1, // Adjust step size for readability
              },
            },
          },
          plugins: {
            legend: { display: true, position: 'bottom' },
            zoom: {
              zoom: { wheel: { enabled: true, modifierKey: 'shift' }, pinch: { enabled: true }, mode: 'xy'},
              pan: { enabled: true, mode: 'xy', modifierKey: 'ctrl' },
            },
          },
        };
      },
    },
  };
  </script>
